import produce from "immer";
import {
  FETCH_TOC,
  FETCH_TOC_SUCCESS,
  FETCH_TOC_FAILURE,
  //
  GET_VIEW_DATA,
  GET_VIEW_DATA_SUCCESS,
  GET_VIEW_DATA_FAILURE,
  //
  ADD_TOC,
  ADD_TOC_SUCCESS,
  ADD_TOC_FAILURE,
  //
  EDIT_TOC,
  EDIT_TOC_SUCCESS,
  EDIT_TOC_FAILURE,
  //
  DELETE_TOC,
  DELETE_TOC_SUCCESS,
  DELETE_TOC_FAILURE,
} from "./constants";

export const initialState = {
  isFetchingTOC: false,
  TOC: [],
  // Add / Edit
  isSubmitting: false,
  // View
  isFetching: false,
  currentTOC: {},
  // Delete
  isDeleting: false,
  //
  isSearching: false,
};

const TOCReducer = (state = initialState, action) =>
  produce(state, (draft) => {
    switch (action.type) {
      // List
      case FETCH_TOC:
        draft.isFetchingTOC = true;
        draft.currentTOC = {};
        break;
      case FETCH_TOC_SUCCESS:
        draft.isFetchingTOC = false;
        draft.TOC = action.payload;
        break;
      case FETCH_TOC_FAILURE:
        draft.isFetchingTOC = false;
        break;
      // View
      case GET_VIEW_DATA:
        draft.isFetching = true;
        draft.currentTOC = {};
        break;
      case GET_VIEW_DATA_SUCCESS:
        draft.isFetching = false;
        draft.currentTOC = action.payload;
        break;
      case GET_VIEW_DATA_FAILURE:
        draft.isFetching = false;
        break;
      // Add
      case ADD_TOC:
        draft.isSubmitting = true;
        break;
      case ADD_TOC_SUCCESS:
        draft.isSubmitting = false;
        break;
      case ADD_TOC_FAILURE:
        draft.isSubmitting = false;
        break;
      // Edit
      case EDIT_TOC:
        draft.isSubmitting = true;
        break;
      case EDIT_TOC_SUCCESS:
        draft.isSubmitting = false;
        break;
      case EDIT_TOC_FAILURE:
        draft.isSubmitting = false;
        break;
      // Delete
      case DELETE_TOC:
        draft.isDeleting = true;
        break;
      case DELETE_TOC_SUCCESS:
        draft.isDeleting = false;
        break;
      case DELETE_TOC_FAILURE:
        draft.isDeleting = false;
        break;
      default:
        return state;
    }
  });

export default TOCReducer;
